import React, { useState, useCallback } from 'react';
import Breadcrumbs from '../Breadcrumbs/Breadcrumbs';
import CatalogHero from '../CatalogHero/CatalogHero';
import Filters from '../Filters/Filters';
import ProductGrid from '../ProductGrid/ProductGrid';
import './CatalogPage.css';

const EMPTY_FILTERS = { sizes: [], colors: [], categories: [] };

const CatalogPage = () => {
  const [activeFilters, setActiveFilters] = useState(EMPTY_FILTERS);

  const handleToggleFilter = useCallback((type, value) => {
    setActiveFilters((prev) => {
      const current = prev[type] || [];
      const updated = current.includes(value)
        ? current.filter((v) => v !== value)
        : [...current, value];
      return { ...prev, [type]: updated };
    });
  }, []);

  const hasActiveFilters =
    activeFilters.sizes.length > 0 ||
    activeFilters.colors.length > 0 ||
    activeFilters.categories.length > 0;

  return (
    <div className="catalog-page">
      <Breadcrumbs items={[{ label: 'Início', to: '/' }, 'Catálogo']} />
      <CatalogHero />
      <main className="catalog-main-content">
        {hasActiveFilters && (
          <div className="catalog-filter-bar">
            <span className="catalog-filter-bar-label">Filtros ativos:</span>
            {[...activeFilters.categories, ...activeFilters.colors, ...activeFilters.sizes].map((v) => (
              <span key={v} className="catalog-filter-tag">
                {v}
              </span>
            ))}
            <button
              className="catalog-filter-clear"
              onClick={() => setActiveFilters(EMPTY_FILTERS)}
            >
              Limpar filtros
            </button>
          </div>
        )}
        <div className="catalog-content-container">
          <Filters
            showColors={true}
            showSizes={true}
            activeFilters={activeFilters}
            onToggleFilter={handleToggleFilter}
          />
          <ProductGrid
            showTitle="CAMISAS"
            showAllButton={false}
            activeFilters={activeFilters}
          />
        </div>
      </main>
    </div>
  );
};

export default CatalogPage;
